var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.357,
    height: 18,
    viewBox: "0 0 17.357 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_search",
    transform: "translate(-0.004 -0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9980",
    "data-name": "Path 9980",
    d: "M16.675,18.019h-.5c0-.024.074-.062,0-.068a.9.9,0,0,1-.564-.359q-1.542-1.6-3.082-3.207c-.338-.351-.68-.7-1.017-1.051-.068-.071-.117-.088-.208-.025a6.25,6.25,0,0,1-.828.486,7.393,7.393,0,0,1-1.893.629,6.488,6.488,0,0,1-1.869.119A8.409,8.409,0,0,1,5.043,14.2a7.29,7.29,0,0,1-2.589-1.482A7.187,7.187,0,0,1,.573,10.106,6.417,6.417,0,0,1,.023,7.9a7.348,7.348,0,0,1,.17-2.3A7.946,7.946,0,0,1,.912,3.777a7.293,7.293,0,0,1,2-2.288,7.737,7.737,0,0,1,1.806-1,6.589,6.589,0,0,1,1.011-.3A4.558,4.558,0,0,1,6.491.107c.039,0,.089.01.122-.044L6.477.02h1.6C8.063.06,8,.027,7.992.076c.019.032.052.022.079.025.178.019.357.027.533.056A6.291,6.291,0,0,1,9.947.551a7.357,7.357,0,0,1,4.259,4.615,6.316,6.316,0,0,1,.317,1.954,7.683,7.683,0,0,1-.08,1.331,7.566,7.566,0,0,1-1.484,3.319c-.149.187-.152.187.017.363l2.805,2.918c.453.472.9.947,1.356,1.417a.912.912,0,0,1-.457,1.483c-.1.018,0,.045,0,.068ZM12.62,7.94a5.691,5.691,0,0,0-1.7-4.58,5.373,5.373,0,1,0-3.135,9.278c2.585-.217,4.851-2.423,4.835-4.7Z",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.848185021259c17c25243aebf21fd57e.svg";
export { ForwardRef as ReactComponent };